const getTabs = (listNode: HTMLElement): HTMLElement[] => {
    return Array.from(listNode.querySelectorAll<HTMLElement>('[role="tab"]'));
};

export const moveFocus = (
    listNode: HTMLElement,
    currentFocus: HTMLElement | null,
    traversalFn: (tabs: HTMLElement[], current: HTMLElement | null) => HTMLElement | null
) => {
    const tabs = getTabs(listNode);
    if (tabs.length === 0) return;

    let wrappedOnce = false;
    let nextFocus = traversalFn(tabs, currentFocus);

    while (nextFocus) {
        if (nextFocus === tabs[0]) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        if (nextFocus.hasAttribute('tabindex')) {
            nextFocus.focus();
            return;
        }
        nextFocus = traversalFn(tabs, nextFocus);
    }
};

export const nextItem = (tabs: HTMLElement[], current: HTMLElement | null): HTMLElement | null => {
    if (!tabs.length) return null;

    if (!current) return tabs.at(0) ?? null;

    const index = tabs.indexOf(current);
    if (index === -1) return null; // current not in list

    return tabs.at(index + 1 === tabs.length ? 0 : index + 1) ?? null;
};

export const previousItem = (tabs: HTMLElement[], current: HTMLElement | null): HTMLElement | null => {
    if (!tabs.length) return null;

    if (!current) return tabs.at(-1) ?? null;

    const index = tabs.indexOf(current);
    if (index === -1) return null; // current not in list

    return tabs.at(index - 1) ?? null;
};
